<template>
  <ul>
    <li v-for="route in routes" :key="route.slug" class="nav-list">
      <NuxtLink
        class="nav-list__link"
        :active-class="'active'"
        :to="route.slug"
        data-test-id="nav-list__link"
        @click="
          useMixpanelTrack('lb2 carrier-profile internal link clicked', {
            from: nuxtRoute.fullPath,
            to: route.slug,
          })
        "
      >
        {{ route.name }}
      </NuxtLink>
    </li>
  </ul>
</template>
<script setup>
const props = defineProps({
  routes: Array,
  default: [],
});
const nuxtRoute = useRoute();
</script>
<style lang="scss" scoped>
.nav-list {
  @apply tw-mb-3;

  &__link {
    @apply tw-bg-white
        tw-text-text-secondary
        tw-border-2
        tw-border-transparent
        tw-border-solid
        tw-rounded-full
        tw-p-4
        tw-text-base
        tw-font-regular
        tw-w-full
        tw-block
        tw-no-underline;

    &:hover {
      @apply tw-bg-grey-light;
    }

    &:focus-visible {
      border-color: #7b61ff;
    }

    &:active {
      @apply tw-bg-grey-base;
    }

    &.active {
      @apply tw-bg-secondary-light-x
        tw-text-secondary-base
        tw-font-medium;

      background-image: none;
    }
  }
}
</style>
